(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery-2"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  const modalNumber = modal.querySelector('.mw-modal-number');
  let currentIndex = 0;

  // NJ: measure how dark the bottom right corner of each image is, just where the number sits (from a small 120px version), so the look number can be
  // white on dark images and dark on light ones. Falls back to the dark number if the image can't be measured.
  const toneCache = new Map();
  function getTone(src) {
    if (!src) return Promise.resolve('light');
    if (toneCache.has(src)) return toneCache.get(src);
    const promise = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const w = img.naturalWidth, h = img.naturalHeight;
          const sw = Math.max(1, Math.round(w * 0.1)), sh = Math.max(1, Math.round(h * 0.06));
          const canvas = document.createElement('canvas');
          canvas.width = sw;
          canvas.height = sh;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, w - sw, h - sh, sw, sh, 0, 0, sw, sh);
          const data = ctx.getImageData(0, 0, sw, sh).data;
          let total = 0;
          for (let i = 0; i < data.length; i += 4) total += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
          resolve(total / (data.length / 4) / 255 < 0.5 ? 'dark' : 'light');
        } catch (error) {
          resolve('light');
        }
      };
      img.onerror = () => resolve('light');
      img.src = src;
    });
    toneCache.set(src, promise);
    return promise;
  }

  function applyTone(numberEl, src) {
    if (!numberEl) return Promise.resolve();
    return getTone(src).then((tone) => numberEl.classList.toggle('is-on-dark', tone === 'dark'));
  }

  // Grid: measure the images as they come near the screen
  const toneObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      toneObserver.unobserve(entry.target);
      applyTone(entry.target.querySelector('.mw-image-gallery__number'), entry.target.dataset.toneSrc);
    });
  }, { rootMargin: '400px 0px' }) : null;

  images.forEach((item) => {
    if (toneObserver) toneObserver.observe(item);
    else applyTone(item.querySelector('.mw-image-gallery__number'), item.dataset.toneSrc);
  });
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
    // NJ: the image's place in the gallery, as on the grid
    if (modalNumber) {
      modalNumber.textContent = String(index + 1);
      modalNumber.classList.remove('is-on-dark');
      getTone(images[index].dataset.toneSrc).then((tone) => {
        if (currentIndex === index) modalNumber.classList.toggle('is-on-dark', tone === 'dark');
      });
    }
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.preventDefault()
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.preventDefault()
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', (e) => {
    e.preventDefault();
    hideModal();
  });

  // NJ: keyboard - arrow keys browse, Escape closes
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('show')) return;
    if (e.key === 'Escape') hideModal();
    if (e.key === 'ArrowLeft') showPrevImage(e);
    if (e.key === 'ArrowRight') showNextImage(e);
  });

  
})()

  } catch(e) { console.error(e); }
})();
})();
